import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { resetPassword } from '../services/operations/authAPI';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { BiArrowBack } from 'react-icons/bi';

const UpdatePassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token } = useParams();
    const { authLoading } = useSelector((state) => state.auth);

    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(resetPassword(formData.password, formData.confirmPassword, token, navigate));
    };

    return (
        <div className="min-h-[calc(100vh-3.5rem)] flex items-center justify-center bg-richblack-900 px-4">
            <div className="w-full max-w-md">
                {/* Card Container */}
                <div className="bg-richblack-800 rounded-xl p-8 shadow-lg border border-richblack-700">
                    {/* Header */}
                    <h1 className="text-3xl font-semibold text-richblack-5 mb-2">
                        Create New Password
                    </h1>
                    <p className="text-richblack-300 mb-8">
                        Your new password must be different from previously used passwords.
                    </p>

                    <form onSubmit={handleSubmit}>
                        {/* New Password */}
                        <label className="block relative">
                            <p className="text-richblack-100 mb-2">
                                New Password <sup className="text-pink-200">*</sup>
                            </p>
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Enter new password"
                                required
                                className="w-full rounded-lg bg-richblack-700 text-richblack-5 p-3 pr-12 border border-richblack-600 focus:border-yellow-50 focus:outline-none transition-colors"
                                style={{ boxShadow: "rgba(255, 255, 255, 0.18) 0px -1px 0px inset" }}
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-[42px] cursor-pointer text-richblack-300 hover:text-richblack-100"
                            >
                                {showPassword ? (
                                    <AiOutlineEyeInvisible className="text-2xl" />
                                ) : (
                                    <AiOutlineEye className="text-2xl" />
                                )}
                            </span>
                        </label>

                        {/* Confirm Password */}
                        <label className="block relative mt-4">
                            <p className="text-richblack-100 mb-2">
                                Confirm Password <sup className="text-pink-200">*</sup>
                            </p>
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                placeholder="Confirm new password"
                                required
                                className="w-full rounded-lg bg-richblack-700 text-richblack-5 p-3 pr-12 border border-richblack-600 focus:border-yellow-50 focus:outline-none transition-colors"
                                style={{ boxShadow: "rgba(255, 255, 255, 0.18) 0px -1px 0px inset" }}
                            />
                            <span
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className="absolute right-3 top-[42px] cursor-pointer text-richblack-300 hover:text-richblack-100"
                            >
                                {showConfirmPassword ? (
                                    <AiOutlineEyeInvisible className="text-2xl" />
                                ) : (
                                    <AiOutlineEye className="text-2xl" />
                                )}
                            </span>
                        </label>

                        {/* Password Requirements */}
                        <div className="mt-4 p-3 bg-richblack-700 rounded-lg border border-richblack-600">
                            <p className="text-richblack-300 text-sm">Password should:</p>
                            <ul className="text-richblack-400 text-sm mt-1 space-y-1">
                                <li className="flex items-center gap-2">
                                    <span className={formData.password.length >= 8 ? "text-caribbeangreen-300" : "text-richblack-400"}>
                                        {formData.password.length >= 8 ? "✓" : "○"}
                                    </span>
                                    Be at least 8 characters long
                                </li>
                                <li className="flex items-center gap-2">
                                    <span className={formData.password === formData.confirmPassword && formData.confirmPassword ? "text-caribbeangreen-300" : "text-richblack-400"}>
                                        {formData.password === formData.confirmPassword && formData.confirmPassword ? "✓" : "○"}
                                    </span>
                                    Passwords match
                                </li>
                            </ul>
                        </div>

                        <button
                            type="submit"
                            disabled={authLoading}
                            className="w-full mt-6 py-3 px-4 rounded-lg bg-yellow-50 text-richblack-900 font-semibold hover:bg-yellow-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {authLoading ? "Resetting..." : "Reset Password"}
                        </button>
                    </form>

                    {/* Back to Login */}
                    <Link to="/login" className="flex items-center gap-2 text-richblack-300 hover:text-richblack-100 mt-6 transition-colors">
                        <BiArrowBack />
                        <span>Back to Login</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default UpdatePassword;
